import React, { useState } from 'react';
import { Box, VStack  } from 'native-base';
import { Caption, H2 } from './Typography';
import { I18nReacher, useTheme } from '@springbig/shared';
import { Card, Button } from './Theme';
import { SpIcon } from './Icon';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type NoDataViewProps = {
    callback: () => void;
    title: I18nReacher;
    message: I18nReacher;
    isLoading: boolean
    iconName: IconProp;
};

export const NoDataPlaceholder = ({
    callback,
    title,
    message,
    isLoading,
    iconName,
}: NoDataViewProps) => {

    const [disabled, setDisabled] = useState(false);

    const {
        primary,
        button_text,
    } = useTheme();

    const handleCallback = () => {

        if (!disabled) {
            callback();
        }

        setDisabled(true);

        setTimeout(() => {

            setDisabled(false);
        }, 3 * 60 * 1000);
    };

    let label = 'common.refresh';

    if (disabled) {
        label = 'common.refreshed';
    }

    if (isLoading) {
        label = 'common.fetching';
    }

    return (
        <VStack flex={1} justifyContent={'center'} alignItems={'center'}>
            <Card
                hasShadow
                alignItems={'center'}
                space={4}
                w={'90%'}
            >
                <Box
                    size={200}
                    borderRadius={'full'}
                    bg={primary}
                    alignItems={'center'}
                    justifyContent={'space-around'}
                    shadow={1}
                >
                    <SpIcon icon={iconName} size={115} color={button_text} />
                </Box>
                <H2 text={title} />
                <Caption textAlign={'center'} text={message}/>
                <Button
                    text={label}
                    onPress={handleCallback}
                    disabled={isLoading || disabled}
                    loading={isLoading}
                />
            </Card>
        </VStack>
    );
};
